import { render, staticRenderFns } from "./setting-message.vue?vue&type=template&id=8be21654&scoped=true&"
import script from "./setting-message.vue?vue&type=script&lang=ts&"
export * from "./setting-message.vue?vue&type=script&lang=ts&"
import style0 from "./setting-message.vue?vue&type=style&index=0&id=8be21654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be21654",
  null
  
)

export default component.exports